// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2Gt5y","dragIcon":"SortableItem_dragIcon__2MUEQ","disabled":"SortableItem_disabled__1U2wF"};